var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("User dashboard "+_vm._s(_vm.profile.email))]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.logout}},[_vm._v("Logout")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }